






























import { Component, Prop, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import ItemProduct from "./ItemProduct.vue";

import DropdownPricingType from "./componentItemProduct/DropdownPricingType.vue";
import { FinanceType, TransactionType } from "@/enums/enums";

const StoreTransaction = namespace("Transaction");

@Component({ components: { ItemProduct, DropdownPricingType } })
export default class SectionItemProductList extends Vue {
  @Prop({}) readonly transactionCreate!: any;

  @StoreTransaction.Action
  private DoAddTransactionItem!: (transactionCreate: any) => void;
  @StoreTransaction.Mutation
  private MutationOnChangeTransactionItem!: (transactionCreate: any) => void;
  @StoreTransaction.Mutation
  private MutationOnHumanEventChangeTransactionItem!: (transactionCreate: any) => void;

  public toggleExpandAndCollapseAll = false;

  public GetTitleItemProductList(transactionCreate: any) {
    let title = "";
    switch (transactionCreate.transactionType) {
      case TransactionType.Quotation:
      case TransactionType.Receipt:
        title = "รายการสินค้า/บริการ";
        break;
      case TransactionType.Invoice:
        if (transactionCreate.financeType == FinanceType.InFlow) {
          title = "รายการสินค้า/บริการ";
        } else {
          title = "รายการ";
        }
        break;
      default:
        title = "รายการ";
        break;
    }
    return title;
  }

  public AddTransactionItem() {
    this.DoAddTransactionItem(this.transactionCreate);
  }
  public OnChangeTransactionItem(humanEvent = false) {
    if (humanEvent === true) {
      this.MutationOnHumanEventChangeTransactionItem(this.transactionCreate);
    } else {
      this.MutationOnChangeTransactionItem(this.transactionCreate);
    }
  }
}
